import * as React from 'react';

import { Col } from '@rematter/ui-web';

type DetailFieldProps = {
  label: string;
  value: React.ReactNode;
};

export const DetailField = ({ label, value }: DetailFieldProps) => (
  <Col className="@DetailField gap-0.5">
    <div className="text-xs font-medium text-neutral/50">{label}</div>
    <div className="text-sm">{value ?? '–'}</div>
  </Col>
);
